import { useQuery } from '@tanstack/react-query';

import { externalServices } from '@hero/services';

const getAddressFor = (addressComponents, val) =>
  addressComponents?.find(item => item?.types.includes(val));

export const useGetZipCode = ({ zipCode, options = {} }) =>
  useQuery([zipCode], () => externalServices.getZipCodePlaces('us', zipCode), {
    ...options,
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: zipCode?.length > 4,
    select: res => {
      const addressComponents = res?.address_components || [];

      const state =
        addressComponents.find(
          item =>
            item.types.includes('administrative_area_level_1') && item.types.includes('political')
        ) || null;

      const cityName =
        getAddressFor(addressComponents, 'locality') ||
        getAddressFor(addressComponents, 'sublocality') ||
        getAddressFor(addressComponents, 'neighborhood') ||
        getAddressFor(addressComponents, 'political') ||
        null;
      return {
        state,
        city: cityName.long_name
      };
    }
  });
